import { Days, Requirements, Basis, Positions } from "./config";
import {formatDateBackend} from "utils";
import { BackendJob, BinaryDigitNum, EditedJob, HireJobDTO, SelectOption, SevenBinaryArray, SevenBinaryDigitsString } from "./types";

import { Location } from "components/BillingLocationSelector";

function stringToBinaryArray(input: SevenBinaryDigitsString): SevenBinaryArray {
  const parts = input.split(",") as [
    string, // 0
    string, // 1
    string, // 2
    string, // 3
    string, // 4
    string, // 5
    string, // 6
  ];

  return parts.map((p) => Number(p) as BinaryDigitNum) as SevenBinaryArray;
}

function binaryArrayToString(arr: SevenBinaryArray): SevenBinaryDigitsString {
  return arr.join(",") as SevenBinaryDigitsString;
}

export const convertAvailabilityForBackend = (displayed: SelectOption[]): SevenBinaryArray => {
    const initial: SevenBinaryArray = [0, 0, 0, 0, 0, 0, 0];
    return displayed.reduce((acc, {id}) => {
        acc[id] = 1;
        return acc;
    }, initial);
}

export const convertAvailabilityForFrontend = (backend: Array<number>) => {
    return backend.reduce((acc, day, index) => {
        if (day === 1) {
            return [...acc, Days[index]]
        } else {
            return acc;
        }
    }, [] as SelectOption[])
}

export function formatEditJobBackend(jobPost: EditedJob): HireJobDTO {
    return {
        locationId: jobPost.location?.id,
        title: jobPost.title,
        description: jobPost.description,
        startDate: formatDateBackend(jobPost.startDate as Date),
        endDate: formatDateBackend(jobPost.endDate as Date),
        approxStart: jobPost?.approxStart,
        approxEnd: jobPost?.approxEnd,
        jobType: jobPost.position?.id,
        basis: jobPost.basis?.id,
        minYearsExp: jobPost?.requirement?.id,
        daysOfWeek: jobPost.availability ? binaryArrayToString(jobPost.availability) : undefined,
        sendEmailTo: jobPost.notificationEmail,
        isOrtho: jobPost.isOrtho,
        isRestorative: jobPost.isRestorative,
        isPublic: jobPost.isPublic,
    }
}

function parseDate(date: any) {
    if (!date) {
        return null as any
    }
    const parsedDate = new Date(date);
    return new Date(parsedDate.getTime() + parsedDate.getTimezoneOffset() * 60000);
}

export function createEditedJob(jobPost: BackendJob): EditedJob {
    return {
        id: jobPost.id,
        title: jobPost.title,
        description: jobPost.description,
        availability: jobPost.daysOfWeek ? stringToBinaryArray(jobPost.daysOfWeek) : undefined,
        approxStart: jobPost.approxStart,
        approxEnd: jobPost.approxEnd,
        startDate: parseDate(jobPost.startDate),
        endDate: parseDate(jobPost.endDate),
        requirement: Requirements.find(({ id }) => id === jobPost.minYearsExp),
        basis: Basis.find(({ id }) => id === jobPost.basis),
        position: Positions[jobPost.jobType ?? 0],
        location: {
            id: jobPost.locationId as number,
            hasCard: true,
            card: {},
            address: jobPost.location_address,
            city: jobPost.location_city,
            province: jobPost.location_province,
        } as Location,
        notificationEmail: jobPost.sendEmailTo,
        isOrtho: jobPost?.isOrtho,
        isRestorative: jobPost?.isRestorative,
        status: jobPost?.status,
        isPublic: jobPost.isPublic,
    }
}
